var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('content-title',{scopedSlots:_vm._u([{key:"mainTitle",fn:function(){return [_vm._v("取り扱いタイル")]},proxy:true},{key:"subTitle",fn:function(){return [_vm._v("tiles")]},proxy:true}])}),_vm._v(" "),_c('some-tiles'),_vm._v(" "),_c('request-erea')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c01865e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerMenus/tiles.vue
// module id = null
// module chunks = 